import { take } from 'redux-saga/effects'
import { initNotificationSystem, addNotification } from '../actions'

export default function* notificationSystem () {
  const { payload: notificationSystem } = yield take(initNotificationSystem)
  while (true) {
    const { payload } = yield take(addNotification)
    notificationSystem.addNotification(payload)
  }
}


// WEBPACK FOOTER //
// app/javascript/src/sagas/notifications.js